import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from 'src/app/services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';

@Component({
  selector: 'app-verification-modal',
  templateUrl: './verification-modal.component.html',
  styleUrls: ['./verification-modal.component.scss']
})
export class VerificationModalComponent implements OnInit {

  maskedAccountNo:any;
  showOTPLoader: boolean =false;
  otpVerificationScreen: boolean;
  isArabic: boolean;
  token:any;
  enableResendcode: boolean;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    // isPasswordInput: true,
    disableAutoFocus: true,
    placeholder: '●',
    inputStyles: {
      width: '36px',
      height: '36px',
      color: '#E00800',
    },
  };
  showOTPError = false;
  OTPErrorMSG: any;
  otp: string = '';
  otpErrorMessage: boolean = false;
  mobileNumber: any;
  otpVerified: boolean = false;
  @Input() data: any;
  pattern = new RegExp(/^-?\d+\.?\d*$/);
  env: any;
  constructor(   private PS: ProductService,
    private translate: TranslateService,    private UTS: UtilitiesService,
    public modal: ModalController, private GAS: GoogleAnalyticsService) { }
 
  ngOnInit(): void {
   this.setOtpData();
   this.env = this.UTS.getENV();
  }


  setOtpData() {
    if(this.data && this.data.viewOtpScreen)  {
      this.maskedAccountNo = this.data.maskedAccountNo
      this.token = this.data.token
      this.mobileNumber =  this.data.mobileNumber
    }
    this.GAS.verificationTracking('Number Verification Initiation');
  }
  resendCodeTimer() {
    // Set the date we're counting down to
    const d = new Date();
    //'Nov 18, 2021 11:29:00'
    const timer =
      d.getUTCMonth() +
      1 +
      ' ' +
      d.getDate() +
      ', ' +
      d.getFullYear() +
      ' ' +
      d.getHours() +
      ':' +
      (d.getMinutes() + 2) +
      ':' +
      d.getSeconds();
    let countDownDate = new Date(timer).getTime();

    // Update the count down every 1 second

    this.enableResendcode = false;
    let x = setInterval(() => {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days: any = Math.floor(distance / (1000 * 60 * 60 * 24));
      days = days < 10 ? '0' + days : days;
      let hours: any = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      hours = hours < 10 ? '0' + hours : hours;
      let minutes: any = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      minutes = minutes < 10 ? '0' + minutes : minutes;

      let seconds: any = Math.floor((distance % (1000 * 60)) / 1000);
      seconds = seconds < 10 ? '0' + seconds : seconds;

      // Output the result in an element with id="demo"
      //days + ':' + hours + ':' +
      if (
        document.getElementById('reSendOtpTimer') &&
        document.getElementById('reSendOtpTimerInSeconds')
      ) {
        document.getElementById('reSendOtpTimer').innerHTML =
          minutes + ':' + seconds + '';
        document.getElementById('reSendOtpTimerInSeconds').innerHTML =
          Number(minutes * 60) + Number(seconds) + '';
        if (document.getElementById('reSendOtpTimer2')) {
          document.getElementById('reSendOtpTimer2').innerHTML =
            minutes + ':' + seconds + '';
        }
      } else {
        clearInterval(x);
      }

      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        this.enableResendcode = true;
      }
    }, 1000);
  }

  changeOTP(otp: string) {
    if(this.ngOtpInput && this.ngOtpInput.otpForm && this.ngOtpInput.otpForm?.value){
      for(let i=0; i<6; i++){
        if(!this.pattern.test(this.ngOtpInput && this.ngOtpInput?.otpForm?.value[`ctrl_${i}`])){
          this.ngOtpInput.otpForm.value[`ctrl_${i}`] = null;
          this.ngOtpInput.otpForm.controls[`ctrl_${i}`]['value'] = null;
          this.ngOtpInput.otpForm.controls[`ctrl_${i}`].setErrors(null);
        }
      }
      if(!this.pattern.test(this.ngOtpInput.currentVal)){
        setTimeout(()=>{
          this.ngOtpInput.currentVal = "";
        },0);
      }
    }
    this.showOTPError = false;
    this.otp = otp;
  }

  validateOtp() {
    this.showOTPError = false;
    this.showOTPLoader = true;
    this.UTS.clearError();
    let req =  {"accountNo":this.mobileNumber,"authType":"otp","authValue":this.otp , "token": this.token};
    this.PS.validateOTP(req).subscribe(
      (resp: any) => {
         this.showOTPLoader = false;
        this.showOTPError = false;
        this.otpErrorMessage = false;
        if (resp.success) {
          this.GAS.verificationTracking('Number Verification Success');
        //  this.modal.dismiss({verified: true});
        this.otpVerified = true;
        } else {
          this.GAS.verificationTracking('Number Verification Failure');
          this.translate.get('OTP_INVALID').subscribe((message) => {
            this.showOTPError = true;
            this.OTPErrorMSG = message;
          });
        //  this.GAS.OTPVerification('error - Not eligible', this.data.productType, this.data.displayName);

        }
      },
      (e: any) => {
        this.showOTPLoader = false;
        this.showOTPError = true;
        this.GAS.verificationTracking('Number Verification Failure');
      //  this.GAS.OTPVerification('error - Not eligible', this.data.productType, this.data.displayName);
        this.UTS.error(e?.error?.errorDescription);
        if (e?.status == '400') {
          if (e?.error?.internalErrorCode == "validateOTP-062") {
            this.otpErrorMessage = true;
          }
        }
      }
    );
  }

  
continue() {
  this.modal.dismiss({verified: true});
}
dismiss(value:any){
  this.modal.dismiss({verified: value});
}
  resendCode() {
    this.UTS.clearError();
    this.PS.getMobileEligibility(this.mobileNumber).subscribe(
      (resp) => {
        if (resp.status == 1 && resp.accountId) {
          this.PS.generateOTP(this.mobileNumber).subscribe(
            (resp) => {
              // this.maskedAccountNo = resp.maskedAccountNo;
              this.token = resp?.token;
              this.otpVerificationScreen = true;
              this.resendCodeTimer();
            },
            (e) => {
              this.OTPErrorMSG = e.error.message;
            }
          );
        } else {
          let errorTitle = 'Invalid number';
          let errorMessage =
            'Sorry, this number isn’t registered with e&. Please try again with another number.';
          if (this.isArabic) {
            errorTitle = 'الرقم غير صحيح';
            errorMessage =
              'عذرًا، هذا الرقم غير مُسجل لدى إي آند. يرجى إعادة المحاولة باستخدام رقم آخر';
          }
          this.OTPErrorMSG = `${errorTitle}: ${errorMessage}`;
        }
      },
      (e) => {
        this.OTPErrorMSG = e.error.message;
      }
    );
  }

}
